module.exports = __webpack_public_path__ + "static/img/11.2377707.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/11.png
// module id = a8V3
// module chunks = 0